import { ErrorMessage } from "@/Common/Api/Dto/ErrorMessage";
import { Guid } from "@/Common/Models/Guid";
import * as ServerOperations from "@/Common/Operations/operations.server";

class ServerEvent {
    public Operation: ServerOperations.Server;
    public SubOperation: number;
    public Data: any;
    public PatientId: Guid;
    public MessageId: string;
    public Errors: ErrorMessage[];
    public Warnings: ErrorMessage[];

    constructor(operation: ServerOperations.Server, subOperation: number, messageId: string, errors?: ErrorMessage[]) {
        this.Operation = operation;
        this.Data = {};
        this.MessageId = messageId;
        this.Errors = errors;
        this.SubOperation = subOperation;
        this.PatientId = null;
        if (this.Errors == null) {
            this.Errors = [];
        }
    }

    public hasErrors(): boolean {
        return this.Errors != null && this.Errors.length > 0;
    }

    public hasWarnings(): boolean {
        return this.Warnings != null && this.Warnings.length > 0;
    }
}

class ServerEventWithRequest<TRequest> extends ServerEvent {
    public requestDto: TRequest;
}

// eslint-disable-next-line @typescript-eslint/ban-types -- using `Function` as the base for a generic type constraint is fine since the signature is specified
class ServerEventWithThen<TRequest, TCallback extends Function> extends ServerEventWithRequest<TRequest> {
    public then: TCallback;
}

export { ServerEvent, ServerEventWithRequest, ServerEventWithThen };
